import React, { useEffect, useState } from "react";
import { Table, Pagination, Spinner, Container } from "react-bootstrap";
import { FaFileAlt, FaLongArrowAltRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import sun from "../images/sun.png";
import kitty from "../images/kitty.png";
import { format } from 'date-fns-jalali';
import carrot from "../images/carrot.png"
import "../styles/home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules"; // یا "swiper" در نسخه‌های قدیمی
import caffe from "../images/caffe.svg"
import "swiper/css";
import "swiper/css/navigation";
import api from "./api";

const STATUS_MAP = {
  finished: "اتمام یافته",
  ongoing: "در حال برگزاری",
  not_started: "شروع نشده",
};

const Home = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(4);
  const [countPages, setCountPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [myclass, setClass] = useState([]);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const [code, setCode] = useState(null);
  const fetchData = async (page) => {

    setLoading(true);
    try {
      const res = await api.get(`/student/api/v1/student-class-home/?page=${page}&page_size=${pageSize}`);
      const json = res.data;

      setData(json.results || []);
      const totalCount = json.count || 0;
      const totalPages = Math.ceil(totalCount / pageSize) || 1;
      setCountPages(totalPages);

      setPage(page);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setCountPages(1);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(page);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch("https://api.pythonteek.com/home/api/v1/cource-list/");
        if (!response.ok) {
          throw new Error("مشکل در دریافت اطلاعات از سرور");
        }
        const data = await response.json();
        setCourses(data);
      } catch (err) {
        setError(err)
      }
    };

    fetchCourses();
  }, []);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > countPages) return;
    fetchData(newPage);
  };

  const renderPaginationItems = () => {
    let items = [];
    for (let number = 1; number <= countPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === page}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return items;
  };
  useEffect(() => {
    api.get('student/api/v1/active-class').then((res) => {

      setClass(res.data);

    }).catch((err) => {
      console.error(err);
    })
  }, []);


  // یک useEffect جدید برای دریافت امتیاز کافه برنامه‌نویسی اضافه کنید
  useEffect(() => {
    const fetchCafeScore = async () => {
      try {
        const response = await api.get('/student/api/v1/student-scores/me/');
        if (response.data && response.data.my_score) {
          setCode(response.data.my_score);
        }
      } catch (err) {
        console.error('خطا در دریافت امتیاز کافه برنامه‌نویسی:', err);
        setCode({ cafe_programming_score: 0 });
      }
    };

    fetchCafeScore();
  }, []);
  return (
    <div className="ms-lg-2 p-3 pt-lg-0 pt-3 pe-0 pe-lg-4" >

      <div className="me-lg-5 me-0 ">
        <div className="student-box my-lg-4 d-none d-lg-block my-4 ms-lg-5 ms-0" style={{ borderRadius: "8px" }}>
          <div className="row px-3 py-2">
            <div className="col-lg-9 mb-lg-0 mb-3 col-12">
              <span>برای دانلود
                <span className="green" > مینی پروفایل </span>
                خودتون در
                <span className="green" > پایتون تیک </span>
                و اشتراک اون در فضای مجازی از دکمه رو به رو استفاده کنین.</span>
            </div>
            <div className="col-lg-3 col-12 justify-content-center d-flex">
              <div>
                <Link className="course-link b-green p-relative " to="../miniprofile" >نمایش مینی پروفایل</Link>
              </div>

            </div>
          </div>
        </div>
        <div className="d-lg-none d-flex justify-content-center" >
          <a href="https://pythonteekcafe.ir/user">
            <div className="px-5 pb-3" style={{ borderBottom: "1px solid rgba(205, 205, 205, 1)" }}>
              <div className=" d-flex justify-content-center">
                <img src={caffe} width={100} height={100} />
              </div>
              <div className="">
                <div style={{ color: "rgba(43, 167, 105, 1)", width: "115px" }}>کافه برنامه نویسی</div>
                <div style={{ fontSize: "13px", color: "#777" }}>
                  <div className=" d-flex justify-content-center">
                    امتیاز:{code?.cafe_programming_score ?? 0}
                  </div>

                </div>
              </div>

            </div>
            <div className="d-flex justify-content-center my-4">
              <Link className="course-link b-green p-relative " to="../miniprofile" >نمایش مینی پروفایل</Link>
            </div>

          </a>


        </div>
        <span className="fw-bold ms-3"> درس های من</span>
        <img src={carrot} width={33} height={33} />
      </div>
      <Container className="my-3 p-3  student-box" style={{ direction: "rtl", maxWidth: "1100px " }}>
        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" role="status" />

          </div>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <Table
                striped
                bordered
                hover
                responsive
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  minWidth: "900px",
                  textAlign: "center",   // همه ستون‌ها وسط‌چین
                  verticalAlign: "middle", // متن‌ها هم وسط عمودی باشن
                }}
              >
                <thead>
                  <tr>
                    <th>فعالیت</th>
                    <th>کد کلاس</th>
                    <th>نام کلاس</th>
                    <th>نام استاد</th>
                    <th>تاریخ شروع</th>
                    <th>زمان کلاس</th>
                    <th>نوع کلاس</th>
                    <th>آدرس</th>
                    <th>جزوه</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center">
                        درسی برای نمایش وجود ندارد.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, idx) => {
                      const statusText = STATUS_MAP[item.status] || "";
                      const isVirtual = item.class_type !== "in_person";

                      return (
                        <tr key={idx}>
                          <td>{statusText}</td>
                          <td>{item.class_code || ""}</td>
                          <td>{item.class_name || ""}</td>
                          <td>{item.teacher_name || ""}</td>
                          <td>
                            {item.start_date ? format(new Date(item.start_date), 'yyyy/MM/dd') : ' '}
                          </td>

                          <td>{item.class_time || ""} </td>
                          <td>{isVirtual ? "مجازی" : "حضوری"}</td>
                          <td>
                            {isVirtual ? (
                              item.online_link ? (
                                <a
                                  href={item.online_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  لینک
                                </a>
                              ) : (
                                "-"
                              )
                            ) : (
                              item.location || "-"
                            )}
                          </td>

                          <td>
                            {item.lesson_note ? (
                              <a
                                href={item.lesson_note}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="مشاهده جزوه"
                              >
                                <FaFileAlt size={18} />
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>

            </div>
            <div className="mx-5 mb-2 mb-lg-0"> <Pagination className="custom-pagination"> <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} > <span style={{ display: "flex", alignItems: "center", gap: "5px" }}> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 24 24" fill="none" > <path d="M8 4L16 12L8 20" stroke="#2D9C4B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </svg> قبلی </span> </Pagination.Prev> {renderPaginationItems()} <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === countPages} > <span style={{ display: "flex", alignItems: "center", gap: "5px" }}> بعدی <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 24 24" fill="none" > <path d="M16 4L8 12L16 20" stroke="#2D9C4B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </svg> </span> </Pagination.Next> </Pagination> </div>
          </>
        )}
      </Container>


      <div className="row me-lg-5">
        <div className="col-lg-7 col-12 ">
          <div>
            <span className="fw-bold ms-3"> مشاهده تکالیف</span>
            <img src={sun} width={33} height={33} />
          </div>
          <div className="student-box my-3">
            {/* بخش لیست کلاس‌ها */}
            <div
              className="row p-4 px-0 pb-3 mx-lg-3 nowrap mx-1"
              style={{
                flexWrap: "nowrap",
                overflowX: "auto",
              }}
            >
              {myclass.map((name, i) => (
                <div
                  className="col-lg-4 col-6"
                  style={{ maxWidth: "200px" }}
                  key={i}
                >
                  <div className="homework-box">
                    <span className="d-flex justify-content-center">
                      {name.teacher_name}
                    </span>
                    <span
                      className="d-flex justify-content-center mt-1"
                      style={{
                        fontSize: "13px",
                        color: "rgba(112, 112, 112, 1)",
                      }}
                    >
                      {name.course_title}
                    </span>
                  </div>
                </div>
              ))}
            </div>


            <div className="d-flex justify-content-center ">
              <button className="gohomework" onClick={() => navigate("/Homework")}>
                مشاهده تکالیف
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-5  col-12" >
          <div>
            <span className="fw-bold ms-3 me-lg-5 me-0"> دوره ها</span>
            <img src={kitty} width={33} height={33} />
          </div>
          <div className="my-map">
            <div className="student-box mt-3 px-2 py-1">
              <div className="">
                <div className="" >

                  <Swiper
                    modules={[Navigation]}
                    navigation
                    breakpoints={{
                      320: { slidesPerView: 2, spaceBetween: 0 },
                      480: { slidesPerView: 2, spaceBetween: 0 },
                      768: { slidesPerView: 3, spaceBetween: 0 },
                      1024: { slidesPerView: 3, spaceBetween: 0 },
                    }}
                  >
                    {courses.map((course, index) => (
                      <SwiperSlide key={index}>
                        <div className="course-logo mx-lg-2 mx-0 ">
                          <div className="mlogo-container d-flex flex-column align-items-center text-center">
                            {course.logo && (
                              <img
                                src={course.logo}
                                alt={course.title}
                                width={90}
                                height={90}
                                style={{ objectFit: "contain" }}
                              />
                            )}
                            <a href={`https://pythonteek.com/pages/coursesdetail/${course.id}`} className="course-link">
                              {course.title}
                            </a>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Home;
